// Shared types for QR & NFC scan result navigation state

export enum TagFlowViewState {
    Compromised = 'Compromised',
    Navigate = 'Navigate',
    NoOwner = 'NoOwner',
    NotAdded = 'NotAdded',
    NotRenki = 'NotRenki',
    TagOwner = 'TagOwner',
    Unknown = 'Unknown',
    WrongDomain = 'WrongDomain',
}

export interface TagResultState {
    error?: string | null;
    ok: boolean;
    raw: string | null;
    redirectUrl: string | null;
    serial?: string | null;
    tech?: readonly string[] | null;
    texts?: readonly { lang: string; text: string }[] | null;
    type: 'qr' | 'nfc';
    uid?: string | null;
}

export function buildQrResultState(params: {
    error?: string | null;
    ok: boolean;
    raw: string | null;
    redirectUrl: string | null;
}): TagResultState {
    return {
        error: params.ok ? null : (params.error ?? null),
        ok: params.ok,
        raw: params.raw ?? null,
        redirectUrl: params.ok ? params.redirectUrl : null,
        type: 'qr',
    };
}

export function buildNfcResultState(params: {
    error?: string | null;
    ok: boolean;
    raw: string | null;
    redirectUrl: string | null;
    tech?: string[] | null;
    texts?: { lang: string; text: string }[] | null;
    uid?: string | null;
}): TagResultState {
    return {
        error: params.ok ? null : (params.error ?? null),
        ok: params.ok,
        raw: params.raw ?? null,
        redirectUrl: params.ok ? params.redirectUrl : null,
        tech: params.tech ?? null,
        texts: params.texts ?? null,
        type: 'nfc',
        uid: params.uid ?? null,
    };
}

export function isTagResultState(obj: unknown): obj is TagResultState {
    if (!obj || typeof obj !== 'object') {
        return false;
    }
    const o = obj as Partial<TagResultState>;
    if (o.type !== 'qr' && o.type !== 'nfc') {
        return false;
    }
    if (typeof o.ok !== 'boolean') {
        return false;
    }
    return true;
}
